// src/components/testpage/TestPageInstructions.jsx
import React from 'react';
import { Typography, Paper } from '@mui/material';

const TestPageInstructions = ({ theme }) => { // Added theme prop for consistency
  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: { xs: 2, sm: 2.5 }, 
        mt: 2, // Margin top to separate from WidgetLoaderControls
        border: `1px dashed ${theme?.palette?.divider || '#e0e0e0'}` // Use theme for border
      }}
    >
      <Typography variant="h6" gutterBottom>
        Testing Notes
      </Typography>
      <Typography 
        variant="body2" 
        component="ul" 
        sx={{ 
          pl: 2, 
          '& li': { mb: 0.5, fontSize:'0.8rem' }, 
          listStyleType: 'disc' 
        }}
      >
        <li>Loader script is <code>loader-v2.js</code> from <code>/static/</code>.</li>
        <li>Uses <code>data-widget-id</code> (for specific version) or <code>data-template-id</code> (for active version).</li>
        <li>Live Panel updates apply via <code>window.banty.updateConfig()</code>.</li>
        <li>"Save Full Config to DB" persists panel state to the <strong>resolved loaded version ID</strong>.</li>
        <li>Check browser console for detailed logs and errors.</li>
        <li>Ensure allowed origins are set for the widget's template in its settings.</li>
      </Typography>
    </Paper>
  );
};

export default TestPageInstructions;